const lang = {
  contact: 'Контакты',
  experience: 'Опыт',
  education: 'Образование',
  skills: 'Навыки',
  about: 'Обо мне'
};

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ru.js